<template>
  <el-dialog
    class="recommend-resume-dialog"
    :title="getTitle()"
    :visible.sync="showDialog"
  >
    <div class="content-confirm border-radius" :key="preventKey+'a'">
      <h1 class="text-center">候选人信息</h1>
      <el-row>
        <el-col>
          <p>
            <span>候选人：{{ confirmInfo.name }}</span>
            <span class="ml-20"
              >性别：{{
                getSelectMapText('WB_GENDER', confirmInfo.gender) || '-'
              }}</span
            >
            <span class="ml-20">手机号：{{ confirmInfo.phone }}</span>
            <span class="ml-20">邮箱：{{ confirmInfo.email }}</span>
          </p>
          <p class="mt-10">
            当前职位：{{ confirmInfo.position
            }}<span class="ml-20">最高学历学校：{{ confirmInfo.school }}</span
            >
          </p>
        </el-col>
      </el-row>
    </div>
    <el-form
      is="el-form"
      :model="ruleForm"
      ref="ruleForm"
      :key="preventKey+'b'"
      class="form-beauty"
      label-width="150px"
    >
      <el-form-item>
        <user-search
          ref="managerSelect"
          v-model="ruleForm.managerId"
          holder="主管"
          :multiple="false"
        ></user-search>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="showDialog = false">取消</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
    </div>
  </el-dialog>
</template>
<script type="text/javascript">
import fetchPositionListMixin from './fetchPositionListMixin'
import selectMapMixin from 'mixins/selectMapMixin'
import formCommonMixin from 'mixins/formCommonMixin'
import UserSearch from 'components/userSelect/searchDownList'
export default {
    mixins: [fetchPositionListMixin, selectMapMixin, formCommonMixin],
    components: {UserSearch},
    data() {
        return {
            showDialog: false,
            isSingle: true,
            confirmInfo: {
                name: '',
                gender: '',
                phone: '',
                email: '',
                position: '',
                school: ''
            },
            preventKey: 1,
            ruleForm: {
                managerId: '',
                resumePositionId: ''
            }
        }
    },
    methods: {
        getTitle() {
            return '设置主管'
        },
        show(data) {
            console.log(data)
            this.preventKey = +new Date()
            this.confirmInfo = {
                name: data.resumeForm.name,
                gender: data.resumeForm.gender,
                phone: data.resumeForm.mobilePhone,
                email: data.resumeForm.email,
                position: data.positionForm.name,
                school: data.resumeForm.resumeMaxEducation.school,
                sLevel: data.resumeForm.resumeMaxEducation.sLevel
            }
            this.ruleForm.resumePositionId = data.id
            if(data.managerInfo) {
                this.$nextTick(() => {
                    if(data.managerInfo.id && data.managerInfo.name) {
                        this.$refs[`managerSelect`].setDefaultValueLater(data.managerInfo.id.toString(), data.managerInfo.name.toString())
                    }
                })
                this.ruleForm.managerId = data.managerInfo.id
            }
      
            this.showDialog = true
        },
        saveForm() {
            let url = '/resumePosition/setManagerInfo.api'
            this.$axios
                .post(
                    url,
                    this.ruleForm,
                    { 'X-showMessage': true }
                )
                .then(res => {
                    this.showDialog = false
                    this.$emit('reload')
                })
                .catch(console.error)
        }
    }
}
</script>
<style type="text/css" lang="scss">
@import '~variable';

.recommend-resume-dialog {
  .content-confirm {
    background-color: $color-primary;
    color: white;
    margin: 0 20px 20px;
    > h1 {
      font-size: 18px;
      padding: 15px;
    }
    > .el-row {
      background-color: #59a0ff;
      padding: 15px;
      border-radius: 0 0 $border-radius $border-radius;
    }
  }
  .content-confirm-multiple {
    margin: 0 0 20px 100px;
    span {
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// managerEditDialog.vue?acd751ac